import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "./styles.scss";
// import { Autoplay } from "swiper";
// import CouponItem from "../Coupons/item";
// import Title from "../Title";
import { checkIfValidDate, fetchData } from "../../utils/helper";
import clsx from "clsx";

const SwiperFileReader = (props) => {
  const {
    filename,
    title,
    logo,
    bgColor,
    theme,
    name,
    preferredWidth,
    preferredHeight,
    type,
  } = props;
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    // const fetchData = async (filename) => {
    //   const response = await fetch(process.env.PUBLIC_URL + filename);
    //   const text = await response?.text();
    //   const lines = text?.trim()?.split("\n");
    //   const headers = lines?.[0]?.split("|");
    //   const data = lines?.slice(1).map((line) => line?.split("|"));
    //   const formattedData = data?.map((line) => {
    //     const row = {};
    //     headers?.forEach((header, i) => {
    //       row[header] = line?.[i];
    //     });
    //     return row;
    //   });
    //   setTableData(formattedData);
    // };

    const fetchDataLocal = async () => {
      let formattedData = await fetchData(filename);
      setTableData(formattedData);
    };
    fetchDataLocal();
  }, [filename]);

  // https://www.youtube.com/watch?v=WFw_SgVlXUY
  // const [page, setPage] = useState(0);
  // const [hasMore, setHasMore] = useState(true);
  // const elementRef = useRef(null);
  // const onInterSection = (entries) => {
  //   const firstEntry = entries[0];
  //   if (firstEntry?.iIntersecting && hasMore) {
  //     fetchData();
  //   }
  // };
  // useEffect(() => {
  //   const observer = new IntersectionObserver(onInterSection);
  //   if (observer && elementRef.current) {
  //     observer.observe(elementRef.current);
  //   }
  //   return () => {
  //     // disconnect observer from observing
  //     if (observer) {
  //       observer.disconnect();
  //     }
  //   };
  // }, [tableData]);

  // const fetchMoreItems = async () => {
  //   const reponse = await fetch(
  //     `https://dummyjson.com/products?limit=10skip=${page * 10}`
  //   );
  //   const data = await response.json();
  //   if (data.products.length === 0) {
  //     setHasMore(false);
  //   } else {
  //     setProducts((prev) => [...prev, ...data.products]);
  //     StreamCopyUsage((p) => p + 1);
  //   }
  // };
  return (
    Array.isArray(tableData) &&
    tableData?.length > 0 &&
    !!tableData && (
      <>
        {/* <Title className="title-of-coupons" content={title} /> */}
        <div
          className={clsx("SwiperFileReader coupons m-top-0", `type-${type}`)}
        >
          <div className="title-of-coupons">{title}</div>
          {type === "listing" ? (
            tableData?.map((item, index) => {
              // console.log(item);
              item.logo = logo;
              item.bgColor = bgColor;
              item.theme = theme;
              item.Name = name;
              item.website = item?.Store?.replaceAll("\r", "");

              const img = item?.["Image Url"];
              const nbumber = img?.split("/")?.[0];
              const id = item?.Id;
              const imgWidth = item?.["Image Width"];
              const imgHeight = item?.["Image Height"];
              const startDate = item?.["Start Date"];

              const shouldRenderSlide =
                imgWidth === preferredWidth &&
                imgHeight === preferredHeight &&
                (img?.indexOf("png") !== -1 || img?.indexOf("jpg") !== -1) &&
                startDate
                  ? checkIfValidDate(item)
                  : imgWidth === preferredWidth &&
                    imgHeight === preferredHeight &&
                    true;

              return (
                shouldRenderSlide && (
                  <a
                    key={id}
                    target="_blank"
                    rel="noreferrer"
                    // rel="noopener"
                    className="link-to-product"
                    href={`https://shareasale.com/r.cfm?b=${id}&u=3585269&m=${nbumber}&urllink=&afftrack=`}
                  >
                    <img
                      alt={!!name ? name : "no title"}
                      border="0"
                      src={`https://static.shareasale.com/image/${img}`}
                    />
                  </a>
                )
              );
            })
          ) : (
            <Swiper
              //   autoHeight={true}
              //   breakpoints={breakpoints}
              //   simulateTouch={true}
              //   allowTouchMove={true}
              //   loop={true}
              freeMode
              slidesPerView={"auto"}
              spaceBetween={32}
              //   modules={[Autoplay]}
              //   autoplay={{
              //     delay: 4000,
              //     disableOnInteraction: false,
              //   }}
            >
              {tableData?.map((item, index) => {
                // console.log(item);
                item.logo = logo;
                item.bgColor = bgColor;
                item.theme = theme;
                item.Name = name;
                item.website = item?.Store?.replaceAll("\r", "");

                const img = item?.["Image Url"];
                const nbumber = img?.split("/")?.[0];
                const id = item?.Id;
                const imgWidth = item?.["Image Width"];
                const imgHeight = item?.["Image Height"];
                const startDate = item?.["Start Date"];

                const shouldRenderSlide =
                  imgWidth === preferredWidth &&
                  imgHeight === preferredHeight &&
                  (startDate ? checkIfValidDate(item) : true);

                return (
                  shouldRenderSlide && (
                    <SwiperSlide key={index} style={{ width: "auto" }}>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        className="link-to-product"
                        href={`https://shareasale.com/r.cfm?b=${id}&u=3585269&m=${nbumber}&urllink=&afftrack=`}
                      >
                        <img
                          alt={!!name ? name : "no title"}
                          border="0"
                          src={`https://static.shareasale.com/image/${img}`}
                        />
                      </a>
                    </SwiperSlide>
                  )
                );
              })}
            </Swiper>
          )}
        </div>
      </>
    )
  );
};

export default SwiperFileReader;
